// extracted by mini-css-extract-plugin
export var alpha = "_ia-4";
export var alphaInputContainer = "_ia-j";
export var badge = "_ia-b";
export var brandKitGrid = "_ia-l";
export var brandKitItem = "_ia-m";
export var brandKitSwatch = "_ia-n";
export var controls = "_ia-5";
export var formatDropdown = "_ia-h";
export var formatSelector = "_ia-g";
export var hex = "_ia-6";
export var hexInput = "_ia-i";
export var hue = "_ia-3";
export var hueAndAlphaPointer = "_ia-a";
export var percentageLabel = "_ia-k";
export var picker = "_ia-0";
export var rgba = "_ia-8";
export var rgbaSection = "_ia-7";
export var saturation = "_ia-1";
export var saturationPointer = "_ia-9";
export var sliders = "_ia-2";
export var swatch = "_ia-c";
export var swatchDisabled = "_ia-f";
export var swatchRing = "_ia-d";
export var swatchTransparent = "_ia-e";